import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import NavLink from "./NavLinks";
import { Link } from "react-router-dom";
import { colorLogoWhite } from "../../../assets";
import {
  Home,
  Users,
  ListOrdered,
  PenSquare,
  Phone,
  Briefcase,
} from "lucide-react";

const menuVariants = {
  closed: {
    opacity: 0,
    height: 0,
    transition: {
      duration: 0.3,
      staggerChildren: 0.05,
      staggerDirection: -1,
      when: "afterChildren",
    },
  },
  open: {
    opacity: 1,
    height: "auto",
    transition: {
      duration: 0.4,
      staggerChildren: 0.1,
      staggerDirection: 1,
      when: "beforeChildren",
    },
  },
};

const linkVariants = {
  closed: {
    opacity: 0,
    y: -10,
    transition: { duration: 0.2 },
  },
  open: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.3 },
  },
};

const MobileMenu = ({ isOpen, onLinkClick }) => {
  const links = [
    { name: "Home", path: "/realty", icon: <Home size={20} /> },
    { name: "About us", path: "/realty/about-us", icon: <Users size={20} /> },
    {
      name: "Listings",
      path: "/realty/listings",
      icon: <ListOrdered size={20} />,
    },
    { name: "Blog", path: "/realty/blog", icon: <PenSquare size={20} /> },
    { name: "Careers", path: "/realty/careers", icon: <Briefcase size={20} /> },
    { name: "Contact Us", path: "/realty/contact", icon: <Phone size={20} /> },
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          layout
          className="fixed top-20 left-0 right-0 rounded-md  bg-slate-900 text-white z-40 overflow-hidden shadow-lg "
          initial="closed"
          animate="open"
          exit="closed"
          variants={menuVariants}
        >
          <div className="flex flex-col items-center py-4 border-t border-gray-800 ">
            {links.map((link) => (
              <motion.div
                key={link.name}
                className="w-full "
                variants={linkVariants}
              >
                <NavLink path={link.path} isMobile onClick={onLinkClick}>
                  <div className="w-full  flex justify-center">
                    <div className="flex items-center justify-start gap-2 w-[120px] ">
                      <span className="flex justify-center">{link.icon}</span>
                      <span className="text-center">{link.name}</span>
                    </div>
                  </div>
                </NavLink>
              </motion.div>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileMenu;
